<template>
  <div>
      <div class="table-common">
        <a-table
          size="middle"
          :columns="confirmColumns"
          :row-key="record => record.id"
          :data-source="tableData"
          :pagination="pagination"
          :loading="loading"
          bordered
          :locale="{emptyText: '暂无数据'}"
        >
          <template slot="rcvpymtInt" slot-scope="text,record">{{record.rcvpymtInt ? (utils.splitK(record.rcvpymtAmt) + '+' + utils.splitK(record.rcvpymtInt)) : utils.splitK(record.rcvpymtAmt)}}</template>
        </a-table>
      </div>
  </div>
</template>

<script>
import { getBuyrPymClsfDtlDetail } from "@/api/buyrPym.js";
export default {
    props:{
        aplyId:{
            type:String,
            required: true
        }
    },
    name:"recordDetailModal",
    data() {
        return {
            confirmColumns:[
                {
                title: "付款金额(元)",
                dataIndex: "rcvpymtInt",
                scopedSlots: { customRender: "rcvpymtInt" },
                },
                {
                title: "收款人",
                dataIndex: "rcPtyNm"
                },
                {
                title: "收款账户",
                dataIndex: "rcvAccountNo"
                },
                {
                title: "开户银行",
                dataIndex: "accountBelongBank"
                }
            ],
            tableData:[],
            loading:false,
            pagination: {
                pageSize: 10,
                current: 1,
                total: 0,
            },
        }
    },
    computed: {},
    created() {},
    mounted() {
        this.getTableData();
    },
    methods: {
        getTableData() {
            let params = {};
            params = {
                aplyId:this.aplyId, 
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize
            };
            this.loading = true;
            getBuyrPymClsfDtlDetail(params)
            .then((res) => {
                this.pagination.total = res.data.grid.total;
                this.tableData = res.data.grid.list;
                this.loading = false;
            })
            .catch((err) => {
                console.log(err);
                this.loading = false;
            });
        }
    },
    watch: {
        aplyId(newVal){
            this.getTableData();
        }
    }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/bill-payment/record-detail-modal.vue